
/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, computed, ref, onBeforeMount } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { getInitials, timeAgo } from "../../utils/functions";
import Header from "../../components/header/index.vue";
import AddCandidatesForm from "../../components/addCandidateForm/index.vue";
import CandidateInfo from "../../components/candidateInfo/index.vue";
import EditCandidateForm from "../../components/editCandidate/index.vue";
import { useState } from "../../composables/useState";

const CandidateDetail = defineComponent({
  name: "CandidateDetail",
  components: {
    Header,
    CandidateInfo,
    Loading,
  },
  setup() {
    const formRef = ref<InstanceType<typeof AddCandidatesForm>>();
    const editRef = ref<InstanceType<typeof EditCandidateForm>>();
    const store = useStore();
    const jobStore = computed(() => store.state.addCanidates.data);
    const userInfo = computed(() => store.state.candidateInfo.data);
    const candidates = computed(() => store.state.jobCandidates.data);
    const route = useRoute();
    const isLoading = ref(true);
    const jobId = route.query.id;
    const candidateId = route.query.candidateId;
    const showModal = ref(false);
    const showDelete = ref(false);
    const toggleInfo = ref(false);
    const selectedUser: any = ref(0);
    const isMenuOpen = ref(false);
    const showOption = ref("");
    const [showSearch, setShowSearch] = useState(false);
    const activeTab: any = ref(route.query.by_stage_name);
    const resetSelected = () => (selectedUser.value = 0);
    const inputValue = ref("");
    onBeforeMount(async () => {
      await getCandidateData(candidateId, jobId);
      await store.dispatch("getJobState", jobId);
    });
    const reloadCandidate = () => {
      toggleInfo.value = true;
      isLoading.value = true;
      const buildParams = {
        jobId,
        userId: userInfo.value?.id,
      };
      const data = { jobId, filters: { by_stage_name: activeTab.value } };
      showOption.value = "";
      store.dispatch("getJobCandidatesState", data);
      store
        .dispatch("getCandidateState", buildParams)
        .then((res) => {
          showOption.value = "info";
          isLoading.value = res;
        })
        .catch((err) => {
          isLoading.value = err;
        });
    };
    const getCandidateData = (candidateId: any, jobId: any) => {
      editRef?.value?.resetAll();
      selectedUser.value = candidateId;
      toggleInfo.value = false;
      showOption.value = "";
      toggleInfo.value = true;
      isLoading.value = true;
      const buildParams = {
        jobId,
        userId: candidateId,
      };
      store
        .dispatch("getCandidateState", buildParams)
        .then((res) => {
          showOption.value = "info";
          isLoading.value = res;
        })
        .catch((err) => {
          isLoading.value = err;
        });
    };
    return {
      userInfo,
      activeTab,
      candidates,
      jobStore,
      getInitials,
      showModal,
      showDelete,
      toggleInfo,
      formRef,
      getCandidateData,
      route,
      reloadCandidate,
      selectedUser,
      isMenuOpen,
      isLoading,
      showOption,
      editRef,
      resetSelected,
      timeAgo,
      inputValue,
      setShowSearch,
      showSearch,
      jobId,
      candidateId,
    };
  },
});

export default CandidateDetail;
